import { useTranslation } from 'react-i18next';
import ProfileIcon from '../../../assets/icons/profile.svg?react';
import type { AffectedPatient } from '../../../services/roomNeedsAllocationService';
import styles from './KpiDistributionPopover.module.css';

interface BedOverbookingSectionProps {
  title: string;
  patients: readonly AffectedPatient[];
}

// One bed problem in the week and the patients it affects.
export const BedOverbookingSection = ({ title, patients }: BedOverbookingSectionProps) => {
  const { t } = useTranslation();

  return (
    <section className={styles.section}>
      <div className={styles.sectionTitle}>{title}</div>
      <div className={styles.affectedHeader}>{t('gantt-overbooking-affected')}</div>
      <ul className={styles.patientList}>
        {patients.map((patient) => (
          <li key={patient.id} className={styles.patientRow}>
            <ProfileIcon className={styles.patientIcon} aria-hidden="true" />
            {patient.name}
          </li>
        ))}
      </ul>
    </section>
  );
};
